const authentication = require('../../../react-azure-adb2c2').default;

export const get_chatdata = (values: any) => {

  // let url = `http://localhost:5000/v1/room/support/m/chats/get_chatdata`;
  let url = process.env.REACT_APP_API_PM_URL + `/v1/room/support/m/chats/get_chatdata`;


  const token = authentication.getAccessToken();

  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));
};


export const get_subdata = (values: any) => {

  // let url = `http://localhost:5000/v1/room/support/m/chats/get_subdata`;
  let url = process.env.REACT_APP_API_PM_URL + `/v1/room/support/m/chats/get_subdata`;


  const token = authentication.getAccessToken();

  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));
};

export const get_entered = (values: any) => {


  // let url = `http://localhost:5000/v1/room/support/m/devices/get_entered`;
  let url = process.env.REACT_APP_API_PM_URL + `/v1/room/support/m/devices/get_entered`;


  const token = authentication.getAccessToken();

  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));
};


export const signup_count = (values: any) => {


  // let url = `http://localhost:5000/v1/rent/contracts/signup_count`;
  // let url = process.env.REACT_APP_API_PM_URL + `/v1/rent/contracts/signup_count`;
  let url = process.env.REACT_APP_API_ROOMS_URL + '/v1/rent/contracts/signup_count';
  const token = authentication.getAccessToken();

  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));
};


export const splus_count = (values: any) => {


  // let url = `http://localhost:5000/v1/rent/contracts/splus_count`;
  let url = process.env.REACT_APP_API_PM_URL + '/v1/rent/contracts/splus_count';

  const token = authentication.getAccessToken();

  return fetch(url, {
    method: 'post',
    body: JSON.stringify(values),
    headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
  }).then(res => res.json())
    .then(payload => ({ payload }))
    .catch(error => ({ error }));
};